import React, {useState} from "react";
import {Button, Form, Input, message, Modal} from "antd"
import {editGrouponPlatform} from "../../../api/groupon"
import {usePlatformSettingContext} from "../store/usePlatformSettingContext"
import {EditOutlined} from "@ant-design/icons";

const PlatformSettingEdit = ({record}) => {

    const {getPlatformList} = usePlatformSettingContext()


    const [isShow, setIsShow] = useState(false)
    const [isConfirmLoading, setIsConfirmLoading] = useState(false)
    const [form] = Form.useForm()

    const handleClick = () => {
        form.setFieldsValue({name: record.name})
        setIsShow(true)
    }

    const handleFinish = async () => {
        setIsConfirmLoading(true)
        try {
            await editGrouponPlatform({
                id: record.id,
                clubId: sessionStorage.getItem('club_id'),
                name: form.getFieldValue('name')
            }).then(res => {
                if (res.status !== 1) {
                    throw new Error(res.detail)
                }
                message.success('修改成功')
                getPlatformList()
                setIsShow(false)
            })
        } catch (e) {
            message.error(e.message)
        } finally {
            setIsConfirmLoading(false)
        }
    }

    return (
        <div>
            <Button type={"primary"} onClick={handleClick} icon={<EditOutlined/>}>编辑</Button>
            <Modal
                title={"修改团购名称"}
                open={isShow}
                confirmLoading={isConfirmLoading}
                onCancel={() => {
                    setIsShow(false)
                }}
                onOk={form.submit}
            >
                <Form
                    form={form}
                    onFinish={handleFinish}
                >
                    <Form.Item
                        label={"团购名称"}
                        name={"name"}
                        rules={[{required: true, message: "请输入团购名称"}]}
                    >
                        <Input placeholder="请输入团购名称"/>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

export default PlatformSettingEdit


// WEBPACK FOOTER //
// ./src/containers/PlatformSetting/components/PlatformSettingEdit.js